import React from "react";
import { Drawer } from "@mui/material";
import ParallelDrawer from "./ParallelDrawer";
import SubDrawerRenderer from "./SubDrawerRenderer";

const CustomDrawer = ({
  open,
  onClose,
  anchor = "right",
  width = "25vw",
  minWidth = "400px",
  parallelDrawer,
  children,
  enablePropagation,
  anchorParentRef,
  fullHeight = true,
  showSubDrawer,

  withSubDrawerWidth = "45vw",
  inverseSubDrawer = false,
  subDrawer,
  headerText = "Sub Drawer",
  headerAction = null,
  ...props
}) => {
  if (parallelDrawer) {
    return (
      <ParallelDrawer
        open={open}
        onClose={onClose}
        anchor={anchor}
        width={width}
        fullHeight={fullHeight}
        anchorParentRef={anchorParentRef}
      >
        {children}
      </ParallelDrawer>
    );
  }

  if (subDrawer) {
    return (
      <SubDrawerRenderer
        anchorParentRef={anchorParentRef}
        open={open}
        onClose={onClose}
        headerText={headerText}
        headerAction={headerAction}
        inverseSubDrawer={inverseSubDrawer}
      >
        {children}
      </SubDrawerRenderer>
    );
  }

  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          // width: showSubDrawer ? "45vw" : width,
          width: showSubDrawer ? (inverseSubDrawer ? "45vw" : withSubDrawerWidth) : width,
          minWidth,
          flexDirection: showSubDrawer ? "row" : "column",
          transition: "width 2s",
        },
        onClick: (e) => {
          if (!enablePropagation) e.stopPropagation();
        },
      }}
      {...props}
    >
      {children}
    </Drawer>
  );
};

export default CustomDrawer;
